export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q01_b.d567471b.png";